import React from 'react';
import { Mail, Send, CalendarClock, Inbox, Sparkles } from 'lucide-react';
import { relativeTime } from '../utils/format';

const TYPE_META = {
  brief_sent: { icon: Send, label: 'Brief sent', dot: 'bg-[#117049]' },
  executive_brief_sent: { icon: Sparkles, label: 'Executive brief', dot: 'bg-[#1c4ed8]' },
  scheduled_report_sent: { icon: CalendarClock, label: 'Scheduled report', dot: 'bg-[#1c4ed8]' },
  digest_sent: { icon: Mail, label: 'Digest sent', dot: 'bg-[#1c4ed8]' },
  report_scheduled: { icon: CalendarClock, label: 'Report scheduled', dot: 'bg-[#76829a]' },
};

function EmailActivityTimeline({ activity = [], onViewAll, compact = false }) {
  const items = activity.slice(0, compact ? 5 : 12);

  return (
    <div className="bg-white rounded-lg border border-[#e1e5ec] p-[18px]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-[15px] font-semibold text-[#0d1524]">Activity</h3>
        {onViewAll && (
          <button type="button" onClick={onViewAll} className="text-xs font-medium text-[#1c4ed8] hover:underline">
            View all
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="text-center py-6">
          <Inbox size={24} className="mx-auto text-[#76829a] mb-2" />
          <p className="text-sm text-[#5b6780]">No emails sent yet</p>
          <p className="text-xs text-[#76829a] mt-1">Send a brief from any story to start</p>
        </div>
      ) : (
        <div className="relative pl-1">
          <div className="absolute left-[5px] top-2 bottom-2 w-px bg-[#e1e5ec]" />
          <div className="space-y-4">
            {items.map(item => {
              const meta = TYPE_META[item.type] || TYPE_META.brief_sent;
              const Icon = meta.icon;
              return (
                <div key={item.id} className="flex items-start gap-3 pl-0">
                  <span className={`relative z-10 w-2.5 h-2.5 rounded-full mt-1.5 flex-shrink-0 ring-2 ring-white ${meta.dot}`} />
                  <div className="min-w-0 flex-1 -mt-0.5">
                    <div className="flex items-center gap-1.5 text-xs text-[#76829a]">
                      <Icon size={11} />
                      <span>{meta.label}</span>
                      <span>·</span>
                      <span>{relativeTime(item.createdAt)}</span>
                    </div>
                    <p className="text-[13px] font-medium text-[#0d1524] mt-0.5 line-clamp-1">
                      {item.subject}
                    </p>
                    <p className="text-xs text-[#5b6780] mt-0.5 truncate">
                      To {item.recipient}
                      {item.company && <span> · {item.company}</span>}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default EmailActivityTimeline;